import { PropsWithChildren, ReactNode, SyntheticEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@material-ui/core'
import { GridColDef, GridRowParams, MuiEvent } from '@material-ui/data-grid'
import { ROUTES } from '../../../../constants'
import StarIcon from 'assets/icons/StarIcon'
import { Accountant } from 'models/management.models'
import { useManagementAccountantsContainerContext } from 'containers/Management/ManagementAccountants/ManagementAccountantsContainer/ManagementAccountantsContainer'
import SydTable from 'components/Shared/SydTable/SydTable'
import ManagementAccountantsDeleteButton from '../ManagementAccountantsDeleteButton/ManagementAccountantsDeleteButton'
import './styles.scss'

const ManagementAccountantsTable = () => {
  const { managementAccountantsPaginatedData } =
    useManagementAccountantsContainerContext()

  const navigate = useNavigate()

  const PaddedBox = ({ children }: PropsWithChildren<ReactNode>) => (
    <Box paddingLeft={2}>{children}</Box>
  )

  const accountantsHeader: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      width: 75,
      renderHeader(params) {
        return <PaddedBox>{params.colDef.headerName}</PaddedBox>
      },
      renderCell(params) {
        return <PaddedBox>{params.formattedValue}</PaddedBox>
      },
    },
    {
      field: 'name',
      headerName: 'Nombre',
      sortable: false,
      minWidth: 120,
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Correo',
      sortable: false,
      minWidth: 250,
      flex: 2,
    },
    {
      field: 'numWorkspaces',
      headerName: 'Espacios de trabajo',
      sortable: false,
      minWidth: 140,
      flex: 1,
      headerAlign: 'center',
    },
    {
      field: 'team',
      headerName: 'Equipo asignado',
      sortable: false,
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
    },
    {
      field: 'complexity',
      headerName: 'Coeficiente de complejidad',
      sortable: false,
      minWidth: 250,
      flex: 1.5,
      headerAlign: 'center',
    },
    {
      field: 'nps',
      headerName: 'NPS promedio',
      sortable: false,
      minWidth: 120,
      flex: 1,
      renderCell(params) {
        return (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="left"
            flex={1}
            gridGap={4}>
            <StarIcon />
            <Box>{params.formattedValue}</Box>
          </Box>
        )
      },
    },
    {
      field: 'pendingWorkspaces',
      headerName: 'Cierres incompletos',
      sortable: false,
      minWidth: 150,
      flex: 1.5,
      headerAlign: 'center',
    },
    {
      field: '',
      headerName: '',
      sortable: false,
      width: 120,
      renderCell: params => (
        <ManagementAccountantsDeleteButton
          accountant={params.row as Accountant}
        />
      ),
    },
  ]

  return (
    <div className="management-accountants-table">
      <SydTable
        {...managementAccountantsPaginatedData}
        columns={accountantsHeader}
        checkboxSelection={false}
        noBorder
        withRadius
        withShadow
        onRowClick={(row: GridRowParams, event: MuiEvent<SyntheticEvent>) => {
          navigate(`${ROUTES.EMPLOYEE_DETAILS}?id=${row.row.idUser}`)
        }}
      />
    </div>
  )
}

export default ManagementAccountantsTable
